
import React, { useEffect, useState } from 'react'
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout'
import { Box, Button, Card, Tab, Tabs } from '@mui/material'
import { Add, ArrowBack } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import SectionList from './Section/SectionList'
import Sections from './Section/Sections'
import SectionItems from './SectionItem/SectionItems'

const HomeScreen = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'home-screen'
        });
    }, []);
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState('sections');
    // fetch path if it contaions /customer-app/home-screen/section then set tab value to section else if it contains /customer-app/home-screen/section-item then set tab value to section-item
   useEffect(() => {
    if (window.location.pathname.includes('/customer-app/home-screen/section-item')) {
        setTabValue('section-item-list');
        console.log('section-item path');
    } else if (window.location.pathname.includes('/customer-app/home-screen/section')) {
        setTabValue('sections');
        console.log('section path');
    }
}, []);
    // Handle tab change and update URL
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        // navigate(`/customer-app/home-screen/${newValue}`);
    };
    // useEffect(()=>{
    //     if(tabValue === 'section'){
    //         navigate(`/customer-app/home-screen/section`);
    //     }else if(tabValue === 'section-item'){
    //         navigate(`/customer-app/home-screen/section-item`);
    //     }
    // },[tabValue])
  return (
    <>
        <PageHeaderLayout headerTitle={'Manage Home Screen'}>
            <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<Add/>} onClick={()=>navigate('/customer-app/home-screen/section/0')}>
                Add Section
            </Button>
            <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<Add/>} onClick={()=>navigate('/customer-app/home-screen/section-item/0')}>
                Add Section Item
            </Button>
            <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<ArrowBack/>} onClick={()=>navigate(-1)}>
                Back
            </Button>
        </PageHeaderLayout>
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    sx={{ p: 0, minHeight: '40px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >    
                    {/* <Tab value="section" label="Add/Edit Section" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} /> */}
                    <Tab value="sections" label="Section List" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                    {/* <Tab value="section-item" label="Add/Edit Section Item" sx={{ minHeight: '40px' , textTransform: 'capitalize'}} /> */}
                    <Tab value="section-item-list" label="Section Item List" sx={{ minHeight: '40px' , textTransform: 'capitalize'}} />
                </Tabs>
            </Box>
        </Card>
        {tabValue === 'sections' && <Sections />}
        {tabValue === 'section-item-list' && <SectionItems />}
        {/* {tabValue === 'section' && <AddEditSection />}
        
        {tabValue === 'section-item' && <AddEditItem />}
         */}
    </>
  )
}

export default HomeScreen
